import React from "react";
import PurchaseListSkeleton from "../PurchaseListSkeleton";

const RentedEpisodesSkeleton: React.FC = () => {
  return (
    <div className="relative ps-14 pe-9 pb-20 pt-10 max-lg:px-9 max-md:p-0">
      <div className="relative">
        <h2 className="text-primary text-2xl mb-6 max-md:mb-5 max-md:text-lg flex items-center gap-1">
          RENTED EPISODES{" "}
          <div className="skeleton w-6 min-h-6 !rounded-md"></div>
        </h2>
        <div className="w-full max-md:max-h-full">
          <div className="grid grid-cols-1 gap-3 items-center justify-start max-h-[80vh] max-md:max-h-none overflow-auto md:pe-3 purchase-list-section">
            {[1, 2, 3].map((item) => {
              return (
                <React.Fragment key={item}>
                  <PurchaseListSkeleton />
                  <div className="bg-no-repeat bg-contain bg-center bg-[url('@assets/images/ContactBorder.png')] w-full h-6 last:hidden max-md:hidden"></div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RentedEpisodesSkeleton;
